import React, { Component } from 'react';
import { Col, Row, Input, Button, Form } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import CustomSelect from '../../../Base/Common/CustomSelect'
import { StyledCard } from '../../../Base/Common/CommonUIComponents';
import { DateRangePicker } from 'react-dates';
import { CustomTable } from '../../../Base/Common/CustomTable';
import { getAPI } from '../../../Base/API';
import { handleNotification } from '../../../Base/Notification';
import moment from 'moment';
import PciBookingPayCardDetails from './PciBookingPayCardDetails';

class PciBookingPayCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            block: false,
            modal: false,
            reference: null,
            paycards: null
        };
    }

    componentDidMount() {
        this.getProperties();
    }

    getPayCard = (e) => {
        if (e) e.preventDefault();

        this.setState({ block: true }, _ => {
            const { reference, propertyId, from, to } = this.state;

            var params = '';
            if (propertyId) params += `&propertyId=${propertyId}`;
            if (from) params += `&from=${from}`;
            if (to) params += `&to=${to}`;

            getAPI(result => {
                const { data, error } = result;
                const errorMessage = [];

                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });
                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                        this.setState(({ block: false, error: errorMessage }));
                        return;
                    }

                    this.setState({ paycards: data.response, block: false });
                }
                else {
                    this.setState({ block: false });
                }
            }, `/api/hotel/PCIBooking/v1/paycard/meta?reference=${reference}` + params);
        })
    }

    getProperties = (e) => {
        if (e) e.preventDefault();

        this.setState({ block: true }, _ => {
            
            getAPI(result => {
                const { data, error } = result;
                const errorMessage = [];

                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });
                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                        this.setState(({ block: false, error: errorMessage }));
                        return;
                    }

                    const properties = data.response?.map(prop => ({ value: prop.userId, label: prop.name }))

                    this.setState({ properties, block: false });
                }
                else {
                    this.setState({ block: false });
                }
            }, `/api/hotel/PCIBooking/v1/property/query?limit=9999`);
        })
    }

    handleChangeSelect = (name, combo) => {
        this.setState({
            [name]: combo ? combo.value : null
        });
    };

    handlChange = (e) => {
        const { name, value } = e.target;

        this.setState({ [name]: value });
    }

    toggleModal = (selectedCard) => {
        const token = selectedCard ? selectedCard.split("/").pop() : null;

        this.setState(prevState => ({
            modal: !prevState.modal,
            token
        }))
    }


    render() {
        const { block, error, reference, status, modal, from, to, properties } = this.state;

        const columns = [
            {
                dataField: 'createDate',
                text: "Create Date",
                sort: true,
                formatter: (cell) => cell ? moment(cell).format("YYYY-MM-DD HH:mm") : null
            }, {
                dataField: 'cardType',
                text: "Card Type",
                sort: true,
            }, {
                dataField: 'userID',
                text: "User ID",
                sort: true,
            }, {
                dataField: 'ownerID',
                text: "owner ID",
                sort: true,
            }, {
                dataField: 'ownerName',
                text: "Owner Name",
                sort: true,
            }, {
                dataField: 'issueNumber',
                text: "Issue Number",
                sort: true,
            }, {
                dataField: 'endRetentionDate',
                text: "End Retention Date",
                sort: true,
                formatter: (cell) => cell ? moment(cell).format("YYYY-MM-DD HH:mm") : null
            }, {
                dataField: 'associatedProperties',
                text: "Associated Properties",
                sort: true,
                formatter: (cell) => cell ? cell.map((prop, idx) => <div key={idx}>{prop}</div>) : null
            }
        ]

        const selectRow = {
            mode: 'radio',
            hideSelectColumn: true,
            bgColor: '#f8f9fa',
            clickToSelect: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                this.toggleModal(row.uri)
            }
        };

        return (
            <StyledCard block={block} error={error} title="navbar.PciBookingPayCards" icon="far fa-credit-card">
                <Form onSubmit={this.getPayCard}>
                    <Row className="mb-2 ">
                        <Col className="small">
                            <Input
                                type="text"
                                name="reference"
                                value={reference}
                                onChange={this.handlChange}
                                placeholder={"Reference"}
                                required
                            />
                        </Col>
                        <Col className="small">
                            <CustomSelect
                                options={properties}
                                value={properties?.find(opt => opt.value === status)}
                                onChange={(e) => this.handleChangeSelect('propertyId', e)}
                                placeholder={"Property"}
                                isClearable
                            />
                        </Col>
                        <Col className="small">
                            <DateRangePicker
                                startDate={from ? moment(from).locale(moment.locale()) : null}
                                startDateId="your_unique_start_date_id_announcement"
                                isOutsideRange={() => false}
                                endDate={to ? moment(to).locale(moment.locale()) : null}
                                endDateId="your_unique_end_date_id_announcement"
                                onDatesChange={({ startDate, endDate }) => this.setState({ from: startDate, to: endDate })}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput })}
                                small={true}
                                numberOfMonths={1}
                                showDefaultInputIcon={true}
                                renderMonthElement={({ month }) => moment(month).locale(this.props.intl.locale).format('MMMM YYYY')}
                            />
                        </Col>
                        <Col className="text-right">
                            <Button className="btn btn-host btn-sm" type="submit"><i className="fas fa-search"></i></Button>
                        </Col>
                    </Row>
                </Form>
                <hr />
                <CustomTable
                    keyField="lastDigits"
                    data={this.state.paycards || []}
                    columns={columns}
                    sizePerPage={10}
                    shadow={false}
                    selectRow={selectRow}
                    search={true}
                    remote={false}
                />

                {modal ?
                    <PciBookingPayCardDetails
                        modal={modal}
                        toggleModal={_ => this.toggleModal()}
                        token={this.state.token}
                    />
                    : ''}
            </StyledCard>
        );
    }
}

export default injectIntl(PciBookingPayCard);